export enum PreferenceState {
  PENDING = 'pending',
  SUBSCRIBED = 'subscribed',
  UNSUBSCRIBED = 'unsubscribed',
}

export interface CommunicationPreference {
  key: string
  state: PreferenceState
}

/**
 * Checks if a user is subscribed to a specific communication preference
 * @param preferences - User's communication preferences
 * @param key - The preference key to check
 * @returns True if user is subscribed or pending
 */
export const isSubscribedToCommunication = (
  preferences: CommunicationPreference[] | undefined,
  key: string
): boolean => {
  const prefState =
    preferences?.find((item) => item.key === key)?.state ??
    PreferenceState.UNSUBSCRIBED
  return (
    prefState === PreferenceState.PENDING ||
    prefState === PreferenceState.SUBSCRIBED
  )
}
